
export default {
    aiAssistant: {
        generateResponse: {
            type: 'post',
            showLoader: true,
            success: {
                default: null // No success message for AI responses
            },
            error: {
                default: 'AI request failed. Please try again.',
                400: 'Invalid request. Please check your input.',
                401: 'You are not authorized to use the AI assistant.',
                403: 'You do not have permission to access this patient data.',
                404: 'Patient or resource not found.',
                429: 'Too many AI requests. Please wait a moment and try again.',
                500: 'AI service error. Please try again.',
                503: 'AI service is temporarily unavailable.'
            }
        },
        analyzePatientData: {
            type: 'post',
            showLoader: true,
            success: {
                default: null
            },
            error: {
                default: 'Failed to analyze patient data',
                400: 'Invalid analysis request',
                404: 'Patient or resource not found',
                500: 'Analysis service error'
            }
        },
        summarizePatientData: {
            type: 'post',
            showLoader: true,
            success: {
                default: null
            },
            error: {
                default: 'Failed to summarize patient data',
                400: 'Invalid summary request',
                404: 'Patient or resource not found',
                500: 'Summary service error'
            }
        },
        getChatHistory: {
            type: 'get',
            showLoader: false, // No loader for chat history
            success: {
                default: null
            },
            error: {
                default: 'Failed to load chat history',
                404: 'Chat history not found',
                500: 'Error loading chat history'
            }
        },
        saveGeneratedContent: {
            type: 'post',
            showLoader: true,
            success: {
                default: 'AI content saved successfully',
                201: 'New report created with AI content'
            },
            error: {
                default: 'Failed to save AI content',
                400: 'Invalid content data',
                404: 'Patient or report not found',
                500: 'Error saving content'
            }
        },
        clearChatHistory: {
            type: 'post',
            showLoader: true,
            success: {
                default: 'Chat history cleared successfully'
            },
            error: {
                default: 'Failed to clear chat history',
                404: 'Chat history not found',
                500: 'Error clearing chat history'
            }
        },
        healthCheck: {
            type: 'get',
            showLoader: false, // No loader for health checks
            success: {
                default: null
            },
            error: {
                default: 'AI service is not available',
                500: 'AI service health check failed'
            }
        },
        getConfiguration: {
            type: 'get',
            showLoader: false,
            success: {
                default: null
            },
            error: {
                default: 'Failed to load AI configuration',
                500: 'Configuration service error'
            }
        },
        getSupportedAnalysisTypes: {
            type: 'get',
            showLoader: false,
            success: {
                default: null
            },
            error: {
                default: 'Failed to load analysis types',
                500: 'Analysis types service error'
            }
        },
        getSummaryTypes: {
            type: 'get',
            showLoader: false,
            success: {
                default: null
            },
            error: {
                default: 'Failed to load summary types',
                500: 'Summary types service error'
            }
        },
        getUsageStatistics: {
            type: 'get',
            showLoader: true,
            success: {
                default: null
            },
            error: {
                default: 'Failed to load usage statistics',
                500: 'Statistics service error'
            }
        },
        validateRequest: {
            type: 'post',
            showLoader: false, // Quick validation
            success: {
                default: null
            },
            error: {
                default: 'Request validation failed',
                400: 'Invalid request parameters',
                500: 'Validation service error'
            }
        }
    }
};